/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryMenuComponent } from './history-menu/history-menu.component';
import { HistoryMenuItemComponent } from './history-menu-item/history-menu-item.component';
import { ButtonModule } from 'primeng/button';
import { HistoryMenuConfigModel } from './history-menu-config.model';

@NgModule({
  imports: [CommonModule, ButtonModule],
  declarations: [HistoryMenuComponent, HistoryMenuItemComponent],
  exports: [HistoryMenuComponent]
})
export class HistoryMenuModule {
  static forRoot(config: HistoryMenuConfigModel): ModuleWithProviders<HistoryMenuModule> {
    return {
      ngModule: HistoryMenuModule,
      providers: [{ provide: HistoryMenuConfigModel, useValue: config }]
    };
  }
}
